<template>
    <div class="app">
        <el-table size="mini" ref="moviesTable" id="mxTable" :data="tableData" height="300" @row-dblclick="handleSelectClick" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                  @selection-change="handleSelectionChange" border style=" width: 100%">
            <el-table-column align="center" min-width="180" prop="planName" label="方案名称"></el-table-column>
            <el-table-column align="center" min-width="180" prop="planDesc" label="描述"></el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: 'qhListTemplate',
    props: {
        actionData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            tableData: [],
            selectedRow: [],
            selectedIndex: 0,
            total:0,
        }
    },
    created() {
        this.getDataList();
    },
    methods: {
        async getDataList() {
            const params = {};
            const res = await this.$http.deragetGenPlanList(params);
            this.total = res.result.length;
            this.tableData = res.result;
            if (res.status == 500) {
                this.$message({
                    type: "error",
                    message: res.message,
                });
                return
            }
            if (!this.tableData) return;
            this.$nextTick(() => {
                setTimeout(() => {
                    let refsElTable = this.$refs.moviesTable;
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.tableData[this.selectedIndex]);
                }, 100)
            });
        },
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') {
                rowBackground.backgroundColor = row.bgColor
            }
            return rowBackground
        },
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.moviesTable; // 获取表格对象
            this.selectedIndex = row.rowIndex;
            let findRow = {};
            findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        // 双击确认
        handleSelectClick(row, column, event) {
            // if (this.isChoice) return;
            this.$emit("TranData", row);
        },
        keyUpChild(e) {
            // 表格为空，不执行下方 
            if (!this.tableData) return

            if (e.keyCode == 40) { // 下键
                let refsElTable = this.$refs.moviesTable
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 如果当前没有选中行，则直接选中第一个
                        this.selectedIndex = 0;
                    } else if (this.selectedIndex == this.tableData.length - 1) {
                        // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedIndex = 0;
                    } else {
                        // 正常递增
                        this.selectedIndex++;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.tableData[this.selectedIndex],
                            false
                        );
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.tableData[this.selectedIndex]); // 把现在当前行勾选
                });
            } else if (e.keyCode == 38) {
                // 上键
                let refsElTable = this.$refs.moviesTable;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 当前没有选中行，则直接选中第一个
                        this.selectedIndex = 0;
                    } else if (this.selectedIndex == 0) {
                        // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedIndex = this.tableData.length - 1;
                    } else {
                        // 正常递减
                        this.selectedIndex--;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.tableData[this.selectedIndex],
                            false
                        );
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.tableData[this.selectedIndex]); // 把现在当前行勾选
                });
            }
        },
        keyUpChildEnter(e) {
            // 表格为空，不执行下方 
            if (this.tableData.length == 0 ) {
                return
            }
            if (e.keyCode == 13) {
                this.$emit("TranData", this.tableData[this.selectedIndex]);
            }
        },
    },
    mounted() {
        addEventListener('keyup', this.keyUpChild)
        addEventListener('keyup', this.keyUpChildEnter)
    },
    beforeDestroy() {
        removeEventListener('keyup', this.keyUpChild)
        removeEventListener('keyup', this.keyUpChildEnter)
    },
}
</script>

<style>
</style>